import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import NewsService from "../services/news";
import { Global } from "../utils/general";
import { CalendarOutlined } from "@ant-design/icons";
import ReactMarkdown from 'react-markdown';
const NoticiasRelacionadas = ({ noticias, API_URL_STORAGE }) => (
  <div
    style={{
      marginTop: "40px",
      borderTop: "2px solid #000",
      paddingTop: "20px",
    }}
  >
    {/* Contenedor centrado */}
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      <h2
        style={{
          fontSize: "1.6rem",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        Noticias Relacionadas
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {noticias.map((noti) => (
          <div
            key={noti.id}
            style={{
              display: "flex",
              flexDirection: "column",
              borderBottom: "2px solid #000",
              paddingBottom: "15px",
            }}
          >
            <img
              src={
                noti.images?.length > 0
                  ? `${API_URL_STORAGE}/${noti.images[0].url}`
                  : "https://via.placeholder.com/300x180?text=Sin+imagen"
              }
             // alt={noti.title}
              style={{
                width: "100%",
                height: "180px",
                objectFit: "cover",
                marginBottom: "10px",
              }}
            />
            <div
              style={{
                fontSize: "1rem",
                fontWeight: "bold",
                color: "#C00",
                marginBottom: "5px",
              }}
            >
              {new Date(
                noti.publication_date + "T12:00:00"
              ).toLocaleDateString("es-PE", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </div>
            <Link
              to={`/news-details/${noti.id}`}
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                textDecoration: "none",
                color: "#000",
                lineHeight: "1.3",
              }}
            >
              {noti.title}
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);


export const NewsDetails = () => {
  const { id } = useParams();

  const API_URL_STORAGE = Global.url_storage;
  const [noticia, setNoticia] = useState(null);
  const [otrasNoticias, setOtrasNoticias] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3); // <-- controla cuántas mostrar

  useEffect(() => {
    fetchNoticia();
  }, [id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [id]);

  useEffect(() => {
    if (noticia && noticia?.category_id) {
      fetchOtrasNoticias();
      setVisibleCount(3); // reinicia al cambiar noticia
    }
  }, [noticia]);

  const fetchNoticia = async () => {
    try {
      const result = await NewsService.getNewsById(id);
      if (result.status === 200) {
        setNoticia(result.data);
      } else {
        console.error("No se pudo cargar la noticia.");
      }
    } catch (error) {
      console.error("Error al obtener la noticia:", error);
    }
  };

  const fetchOtrasNoticias = async () => {
    try {
      const result = await NewsService.getAllNews(noticia?.category_id, noticia?.id);
      if (result.status === 200) {
        setOtrasNoticias(result.data); // traemos todas
      }
    } catch (error) {
      console.error("Error al obtener noticias relacionadas:", error);
    }
  };

  const mostrarMas = () => {
    setVisibleCount((prev) => prev + 3);
  };

  if (!noticia) return <p className="text-center mt-5">Cargando noticia...</p>;

  const { title, publication_date, images, full_content } = noticia;

  return (
    <div id="news" style={{ backgroundColor: "#f9fafb" }}>
      <div
        className="container"
        style={{
          maxWidth: "900px",
          margin: "auto",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          padding: "40px",
          boxShadow: "0 0 10px rgba(0,0,0,0.05)",
        }}
      >
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "bold",
            color: "#1f2937",
            marginBottom: "1rem",
          }}
        >
          {title}
        </h1>

        <div
          style={{
            color: "#6b7280",
            marginBottom: "25px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <CalendarOutlined style={{ marginRight: "8px" }} />
          {new Date(publication_date + "T12:00:00").toLocaleDateString("es-PE", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })}
        </div>

        {images && images.length > 0 && (
          <img
            src={`${API_URL_STORAGE}/${images[0].url}`}
            alt={images[0].description || title}
            style={{
              width: "100%",
              borderRadius: "10px",
              objectFit: "cover",
              marginBottom: "30px",
              maxHeight: "450px",
            }}
          />
        )}

        <div style={{ lineHeight: "1.8", fontSize: "1.125rem", color: "#374151" }}>
          <ReactMarkdown>{full_content}</ReactMarkdown>
        </div>
      </div>

      {otrasNoticias.length > 0 && (
        <>
          <NoticiasRelacionadas
            noticias={otrasNoticias.slice(0, visibleCount)}
            API_URL_STORAGE={API_URL_STORAGE}
          />
          {visibleCount < otrasNoticias.length && (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                onClick={mostrarMas}
                style={{
                  backgroundColor: "#C00",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "5px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                Ver más
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};
